module.exports = __webpack_public_path__ + "img/preco_titular.306d08f6.png";